export interface QuestionBlock {
  type: 'text' | 'latex' | 'image' | 'table';
  content?: string;
  s3_key?: string;
  alt_text?: string;
  rows?: string[][];
}

export function textToBlocks(text: string): QuestionBlock[] {
  if (!text?.trim()) return [];
  return [{ type: 'text', content: text }];
}

/**
 * Rebuilds question_blocks after the user edits question_text in the review form.
 * Text segments separated by [DIAGRAM_N] placeholders are reassembled together
 * with the image blocks from the original, allowing URL changes via updatedImageUrls.
 */
export function rebuildBlocksFromEditedText(
  editedText: string,
  originalBlocks: QuestionBlock[] | null | undefined,
  updatedImageUrls?: string[]
): QuestionBlock[] {
  if (!originalBlocks?.length) {
    return textToBlocks(editedText);
  }

  const rebuiltTextBlocks = textToBlocks(editedText);

  const preservedBlocks = originalBlocks
    .filter(block => block.type !== 'text')
    .map((block) => ({ ...block }));

  let imageIndex = 0;

  preservedBlocks.forEach(block => {
    if (
      block.type === 'image' &&
      updatedImageUrls?.[imageIndex]
    ) {
      block.s3_key = updatedImageUrls[imageIndex];
      imageIndex++;
    }
  }
  );

  return [...rebuiltTextBlocks, ...preservedBlocks];
}
